<template>
  <div class="bg" v-if="doctorinfo">
    <div class="doc-infos">
      <div class="doc-cont">
        <div class="doc-head">
          <img :src="doctorinfo.avatar" alt="">
        </div>
        <div class="doc-info">
          <p>{{doctorinfo.zname}}</p>
          <div class="tags">
            <span v-for="(item,index) in doctorinfo.label">{{item}}</span>
          </div>
        </div>
      </div>
      <div class="order-type">
        <img src="../../../static/icons/shipin@3x.png" alt="">
        <div class="type-info">
          <p>视频问诊 <span>￥{{doctorinfo.video_money/100}}</span></p>
          <span>10分钟视频咨询、在线开方、药材快递到家</span>
        </div>
      </div>
    </div>

    <div class="haoyuan-cont">
      <div class="chakan">查看日期</div>
      <div class="dates">
        <div class="date-items" :style="'width:'+(classList.length*3.7+2.3)+'rem;'">
          <div class="date-item" :class="{active:item.id == classesid}" v-for="(item,index) in classList" @click="selectdate(item.id,item.day)">
            <p>{{getzhou(item.day)}}</p>
            <p>{{getdate(item.day)}}</p>
            <p class="youhao">{{item.remark}}</p>
          </div>

        </div>
      </div>
      <div class="haoyuan-list">
        <h3>号源信息 <span v-if="showdate">({{getdate(showdate)+getzhou(showdate)}})</span></h3>
        <ul>
          <li v-for="(item,index) in classTimeList">
            <p class="times">{{gettime(item.start_time)}}~{{gettime(item.end_time)}}</p>
            <p class="shengyu">剩余：<span>{{item.re_number}}</span></p>
            <button :disabled="!item.remark == '有号'" @click="goOrder(item.remark,item.id)">{{item.remark == '有号'?'立即预约':'约满'}}</button>
          </li>
        </ul>
      </div>
    </div>

    <div class="service-info">
      <h3>服务说明</h3>
      <ul>
        <li>您选择问诊时间后，医生将在约定的时间跟您进行联系，请提前进入对话，耐心等待。</li>
        <li>一次问诊时长为10分钟，请您注意沟通时长</li>
        <li>若医生未在预约时间与您进行沟通，请联系客服，重新预约或申请退款</li>
      </ul>
    </div>

  </div>
</template>

<script>
  import http from '../../request/http'

  export default {
    name: 'shipin_order_pay',
    data(){
      return {
        doctorinfo:[],
        classList:[],
        classTimeList:[],
        classesid:'',
        showdate:''
      }
    },
    methods:{
      goOrder(remark,classtimeid){
        if(remark == '有号'){
          this.$router.push({
            path:'/wenzhen_order_pay',
            query:{
              type:3,
              doctorid:this.$route.query.doctorid,
              classesid:this.classesid,
              classtimeid:classtimeid
            }
          })
        }else{
          this.$toast.center('当前号源已约满')
        }
      },
      docinfo(){
        http.post('/api/wap/doctor/class',{
          doctorId:this.$route.query.doctorid
        }).then(res=>{
          console.log(res)
          if (res.data.docInfo[0].label) {
            res.data.docInfo[0].label = res.data.docInfo[0].label.split(",");
          }
          this.doctorinfo = res.data.docInfo[0];
          this.classList=res.data.classList;
          this.classTimeList = res.data.classTimeList;
          this.classesid = res.data.classList[0].id;
          this.showdate = res.data.classList[0].day;
        })
      },
      selectdate(id,dates){
        this.classesid = id;
        this.showdate = dates;
        http.post('/api/wap/doctor/class',{
          doctorId:this.$route.query.doctorid,
          classes_id:id
        }).then(res=>{
          console.log(res)
          this.classTimeList = res.data.classTimeList;
        })
      },
      getdate(dates) {
        var now = new Date(dates),
          y = now.getFullYear(),
          m = ("0" + (now.getMonth() + 1)).slice(-2),
          d = ("0" + now.getDate()).slice(-2);
        //return y + "年" + m + "-" + d + " " + now.toTimeString().substr(0, 8);
        return  m + "月" + d + "日";
      },
      getzhou(dates){
        var now = new Date(dates);
        var day = now.getDay();
        var weeks = new Array("周日", "周一", "周二", "周三", "周四", "周五", "周六");
        var week = weeks[day];
        return week;
      },
      gettime(dates) {
        return dates.toString().substr(0, 5);
      },
    },
    mounted () {
      this.docinfo();
    }
  }
</script>

<style scoped>
  @import "shipin_order_pay.css";
</style>



// WEBPACK FOOTER //
// src/pages/order/shipin_order_pay.vue